import { Component, inject, input } from '@angular/core';
import { NodeGuide } from '@app/models/entity.model';
import { MediaComponent } from '@app/components/media/media.component';
import { TextComponent } from '@app/components/text/text.component';
import { MobiUiCarouselComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { BreakpointService } from '@app/services/breakpoint.service';
import { ComponentSharedModule } from '@app/modules/component.shared.module';
import { IsNewComponent } from '@app/components/is-new/is-new.component';
import { RatingCounterComponent } from '@app/components/rating-counter/rating-counter.component';
import { StripHtmlPipe } from '@app/pipes/strip-html.pipe';

@Component({
  selector: 'mobi-guide-list',
  templateUrl: './guide-list.component.html',
  styleUrls: ['./guide-list.component.scss'],
  standalone: true,
  imports: [
    ComponentSharedModule,
    MediaComponent,
    TextComponent,
    MobiUiCarouselComponent,
    IsNewComponent,
    RatingCounterComponent,
    StripHtmlPipe,
  ],
})
export class GuideListComponent {
  readonly guides = input.required<NodeGuide[]>();

  breakpoint = inject(BreakpointService);
}
